import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./DashBoard.css";
import "./DashBoard-responsive.css";
import "../Task/CSS/task.css";

import { Ripple } from "primereact/ripple";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { Toast } from "primereact/toast";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import {
  CarryForwardDialog,
  CompleteTaskDialog,
  CompletedEvidenceDialog,
  FollowUpDialog,
  isAlreadyCarryForwardRequestedForCurrentDate,
  TaskDetailsDialog,
} from "../Components/Task/TaskActionDialogs";

import ErrorPage from "../../Components/ErrorPage";
import PageLoader from "../../Components/PageLoader";
import InfoModal from "../../Components/InfoModal";
import { goToTop } from "../../Components/goToTop";

import { userProfile } from "../../Api/UserData";
import { Services, services } from "./DashboardSampleData";
import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { fetchAllProjects } from "../../Controllers/Thunks/projectThunks";
import { Project } from "../../Controllers/Types/Project/ProjectInterface";
import { getAllTaskData } from "../../Controllers/Thunks/taskThunks";
import { taskPartChangeStatusApi } from "../../Api/Task/TaskApi";
import { Tasks } from "../../Controllers/Types/Task/TaskInterface";

import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";
import { QuickAccessList } from "../../Controllers/Types/Home/QuickAccessList";
import { getAllQuickAccessData } from "../../Controllers/Thunks/QuickAccessThunks";
import { OverlayPanel } from "primereact/overlaypanel";
import { MenuBarPermission } from "../../Controllers/Types/NewPermission/MenuBarPermission";
import { getAllNewPermissionsThunk } from "../../Controllers/Thunks/NewPermissionThunks";
import QuickAccessLoading from "./QuickAccessLoading";
import { errorDataIcon, noFolderIcon } from "../../Utils/appData";
import { Skeleton } from "primereact/skeleton";
import { checkIsClient, getLoginUserRoleName, UserRoleName } from "../../Utils/LoginUserRoleName";
import { mapSiteMenuOptions, SiteMenuOption } from "../../Controllers/Types/SideMenuBar/SiteMenuOption";
import { getSideMenuOptionService } from "../../Api/HeyTraderService/SideMenuControlService";

interface DisabledMoreOptionProps {
  label: string;
  icon: string;
}

interface TaskStatusOption {
  name: "Pending" | "Ongoing" | "Completed";
  icon: string;
}

const taskStatusOptions: TaskStatusOption[] = [
  {
    name: "Pending",
    icon: "bi bi-hourglass-split",
  },
  {
    name: "Ongoing",
    icon: "bi bi-clock-history",
  },
  {
    name: "Completed",
    icon: "bi bi-check-circle-fill",
  },
];

const DashBoard: React.FC = () => {
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showRightPanel, setShowRightPanel] = useState<boolean>(false);
  const rightPanelRef = useRef<HTMLDivElement>(null);
  const panelToggleButtonRef = useRef<HTMLButtonElement>(null);
  const toast = useRef<Toast>(null);

  const USERID: string = localStorage.getItem("user_id") || "";
  const [userData, setUserData] = useState<any>([]);
  const [dataLoading, setDataLoading] = useState<boolean>(false);

  const [quickAccessList, setQuickAccessList] = useState<QuickAccessList[]>([]);
  const [taskData, setTaskData] = useState<Tasks[]>([]);
  const [selectedTaskData, setSelectedTaskData] = useState<Tasks | null>(null);
  const [completeTaskData, setCompleteTaskData] = useState<Tasks | null>(null);
  const [followUpTaskData, setFollowUpTaskData] = useState<Tasks | null>(null);
  const [carryForwardTaskData, setCarryForwardTaskData] = useState<Tasks | null>(null);
  const [evidenceTaskData, setEvidenceTaskData] = useState<Tasks | null>(null);
  const [statusLoadingTaskId, setStatusLoadingTaskId] = useState<number | string | null>(null);

  const [showTaskViewModal, setShowTaskViewModal] = useState(false);
  const [showCompleteTaskDialog, setShowCompleteTaskDialog] = useState(false);
  const [showFollowUpDialog, setShowFollowUpDialog] = useState(false);
  const [showCarryForwardDialog, setShowCarryForwardDialog] = useState(false);
  const [showEvidenceDialog, setShowEvidenceDialog] = useState(false);
  // const [projectData, setProjectData] = useState<Projects[]>([]);
  // const [currentProjectsCount, setCurrentProjectsCount] = useState<number>(0);
  const [serviceData, setServiceData] = useState<Services[]>([]);
  const [projectsToShow, setProjectsToShow] = useState<Project[]>([]);

  const { loading, currentProjects } = useAppSelector((state) => state.project);
  const { loadingTask, allTasks } = useAppSelector((state) => state.task);

  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const isPermissionAllProjects = useCanEdit("Home", "all_projects");
  const isPermissionCCProjects = useCanEdit("Home", "cc_projects");
  const isPermissionDCCCProjectInfo = useCanEdit("Home", "cc_and_dc_project_info");
  const isPermissionQuickAccess = useCanEdit("Home", "quick_access");
  const isPermissionTodoTask = useCanEdit("Home", "todo_task");
  const isPermissionTaskCompleted = useCanEdit("Task", "task_completed");
  const isPermissionTaskDetailsView = useCanEdit("Task", "details_view");
  const isPermissionTaskEdit = useCanEdit("Task", "edit_task");
  const isPermissionTools = useCanEdit("Bottom Navigation Options", "tools");
  const isPermissionAttendance = useCanEdit("Bottom Navigation Options", "attendance");
  const isPermissionMaterials = useCanEdit("Bottom Navigation Options", "materials");
  const isPermissionProjectSpending = useCanEdit("Bottom Navigation Options", "project-spending");
  const isPermissionShoppingList = useCanEdit("Bottom Navigation Options", "shopping-list");
  const isPermissionClientAccount = useCanEdit("Bottom Navigation Options", "client-account");

  // CHANGE 1
  const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');

  const [menuOptions, setSiteMenuOptions] = useState<SiteMenuOption[]>([]);

  // CHANGE 3
  useEffect(() => {
    const fetchUserRole = async () => {
      const roleName = await getLoginUserRoleName();
      setLoginUserRoleName(roleName);
    };

    fetchUserRole();
  }, []);


  /* Check role */
  const [isClient, setIsClient] = useState<boolean>(false);

  useEffect(() => {
    const checkRole = async () => {
      const [clientResult] = await Promise.all([
        checkIsClient(),
      ]);

      setIsClient(clientResult);
    };

    checkRole();
  }, []);
  /*  */

  // new chnages contribute from dinesh
  useEffect(() => {
    const getOptionMenuData = async () => {
      const res = await getSideMenuOptionService();
      const options = mapSiteMenuOptions(res.body);
      setSiteMenuOptions(options);
    };
    getOptionMenuData();
  }, []);

  // check is lock
  const checkHaveProject = (keyname: string): boolean => {
    if (loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") {
      const filterdata = menuOptions.filter((e) => e.menu_key_name === keyname);

      if (filterdata && filterdata?.length > 0) {
        const x = filterdata[0];
        return (x.shared_project_count > 0);
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  const profileData = async () => {
    if (localStorage.getItem("user_id") && localStorage.getItem("token")) {
      setDataLoading(true);
      const data = await userProfile(localStorage.getItem("token") || "");

      setDataLoading(false);

      if (data.status) {
        setUserData(data.userData);
      } else {
        setError(true);
        setErrorMessage("Something went wrong!");
      }
    } else {
      setError(true);
      setErrorMessage("Something went wrong!");
    }
  };

  useEffect(() => {
    profileData();

    dispatch(fetchAllProjects());

    dispatch(getAllTaskData());
    dispatch(getAllQuickAccessData());
  }, []);

  useEffect(() => {
    const projectsToShow =
      currentProjects.length > 4
        ? currentProjects.slice(0, 4)
        : currentProjects;

    setProjectsToShow(projectsToShow);
  }, [currentProjects]);

  const formatDateForTaskFilter = (date: Date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const getTaskDateValue = (task: Tasks) => {
    return (
      (task as any)?.task_date ??
      (task as any)?.taskDate ??
      (task as any)?.deu_date ??
      ""
    );
  };

  useEffect(() => {
    const today = new Date();
    const formattedToday = formatDateForTaskFilter(today);

    const filteredTask = allTasks.filter(
      (task) => getTaskDateValue(task) === formattedToday
    );
    const tasksToShow =
      filteredTask.length > 5 ? filteredTask.slice(0, 5) : filteredTask;

    setTaskData(tasksToShow);
  }, [allTasks]);

  const quickAccessListData = useAppSelector((state) => state.quickAccessList.quickAccessList);
  const loadingQuickAccessList = useAppSelector((state) => state.quickAccessList.loader);
  const errorQuickAccessList = useAppSelector((state) => state.quickAccessList.errorDisplay);

  useEffect(() => {
    if (quickAccessListData && quickAccessListData.length > 0) {
      setQuickAccessList(quickAccessListData);
    }
  }, [quickAccessListData]);

  const formatDate = () => {
    const today = new Date();

    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayOfWeek = days[today.getDay()];
    const dayOfMonth = today.getDate();
    const month = months[today.getMonth()];
    const year = today.getFullYear();

    const nth = (d: number) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${dayOfWeek} ${dayOfMonth}${nth(dayOfMonth)} ${month}, ${year}`;
  };
  const todayDate = formatDate();

  useEffect(() => {
    const fetchData = async () => {
      setServiceData(services);
    };
    fetchData();
  }, []);

  const handleToggleRightPanel = () => {
    setShowRightPanel(!showRightPanel);
  };

  const goToQuickAccessFolder = (folder: QuickAccessList) => {
    navigate(`/quick-access`, { state: { quickAccessData: folder } });
    goToTop();
  };

  /* ***************************** For task table ***************************** */
  const showToast = (message: {
    severity: "success" | "error" | "warn" | "info";
    summary: string;
    detail: string;
  }) => {
    toast.current?.show({
      severity: message.severity,
      summary: message.summary,
      detail: message.detail,
      life: 3000,
    });
  };

  const refreshTaskData = async () => {
    dispatch(getAllTaskData());
  };

  const normalizeStatus = (value?: string | null) => {
    const status = String(value ?? "").trim().toLowerCase();

    if (status === "completed") return "Completed";
    if (status === "ongoing") return "Ongoing";
    if (status === "pending") return "Pending";

    return "";
  };

  const getTaskMainStatus = (task: Tasks): "Pending" | "Ongoing" | "Completed" => {
    const modelStatus = normalizeStatus((task as any)?.status);

    if (modelStatus === "Completed") return "Completed";
    if (modelStatus === "Ongoing") return "Ongoing";
    if (modelStatus === "Pending") return "Pending";

    if (task.is_completed === 1) return "Completed";

    return "Ongoing";
  };

  const isTaskCompleted = (task: Tasks) => {
    return getTaskMainStatus(task) === "Completed" || task.is_completed === 1;
  };

  const getStatusClass = (status: string) => {
    return status
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  };

  const getStatusIconClass = (status: string) => {
    if (status === "Completed") return "bi bi-check-circle-fill";
    if (status === "Ongoing") return "bi bi-clock-history";
    return "bi bi-hourglass-split";
  };

  const statusValueTemplate = (option: TaskStatusOption, rowData: Tasks) => {
    const currentStatus = getTaskMainStatus(rowData);
    const statusClass = getStatusClass(currentStatus);
    const isLoading = statusLoadingTaskId === rowData.task_id;

    return (
      <button
        type="button"
        className={`task_status_btn status_${statusClass} p-ripple`}
      >
        <i
          className={
            isLoading
              ? "bi bi-arrow-repeat task_status_spin"
              : getStatusIconClass(currentStatus)
          }
        ></i>
        <span>{currentStatus}</span>
        <i className="bi bi-chevron-down ms-1"></i>
        <Ripple />
      </button>
    );
  };

  const statusOptionTemplate = (option: TaskStatusOption) => {
    const statusClass = getStatusClass(option.name);

    return (
      <div className={`task_status_option status_${statusClass}`}>
        <i className={option.icon}></i>
        <span>{option.name}</span>
      </div>
    );
  };

  const changeTaskStatus = async (
    task: Tasks,
    status: "Pending" | "Ongoing" | "Completed"
  ) => {
    if (!isPermissionTaskEdit) {
      showToast({
        severity: "warn",
        summary: "Permission denied",
        detail: "You do not have permission to change task status.",
      });
      return;
    }

    if (isTaskCompleted(task)) {
      showToast({
        severity: "warn",
        summary: "Action blocked",
        detail: "Completed task status cannot be changed here.",
      });
      return;
    }

    setStatusLoadingTaskId(task.task_id);

    const response = await taskPartChangeStatusApi(task.task_id, status);

    setStatusLoadingTaskId(null);

    const success = response?.statusCode === 200 || response?.status === true;

    if (success) {
      await refreshTaskData();

      showToast({
        severity: "success",
        summary: "Success",
        detail: `Task status changed to ${status}.`,
      });
    } else {
      showToast({
        severity: "error",
        summary: "Error",
        detail: response?.massage ?? "Unable to change task status.",
      });
    }
  };

  const handleStatusChange = (task: Tasks, option: TaskStatusOption | null) => {
    if (!option) return;

    if (option.name === "Completed") {
      if (!isPermissionTaskCompleted) {
        showToast({
          severity: "warn",
          summary: "Permission denied",
          detail: "You do not have permission to complete task.",
        });
        return;
      }

      // 2026-07-13 NOTICE: Boss requested the evidence-based completion feature
      // to be stopped temporarily. Keep this call for restoring the flow later.
      // openCompleteTaskPopup(task);
      // return;
      changeTaskStatus(task, option.name);
      return;
    }

    if (getTaskMainStatus(task) === option.name) return;

    changeTaskStatus(task, option.name);
  };

  const getStatusLabel = (rowData: Tasks) => {
    return getTaskMainStatus(rowData);
  };

  const openCompleteTaskPopup = (task: Tasks) => {
    if (isTaskCompleted(task)) {
      setEvidenceTaskData(task);
      setShowEvidenceDialog(true);
      return;
    }

    if (isAlreadyCarryForwardRequestedForCurrentDate(task)) {
      setSelectedTaskData(task);
      setShowTaskViewModal(true);
      return;
    }

    setCompleteTaskData(task);
    setShowCompleteTaskDialog(true);
  };

  const openFollowUpPopup = (task: Tasks) => {
    if (isTaskCompleted(task)) return;
    if (isAlreadyCarryForwardRequestedForCurrentDate(task)) return;
    if ((task.followup_data ?? []).length > 0) return;

    setFollowUpTaskData(task);
    setShowFollowUpDialog(true);
  };

  const openCarryForwardPopup = (task: Tasks) => {
    if (isTaskCompleted(task)) return;
    if (isAlreadyCarryForwardRequestedForCurrentDate(task)) return;
    if ((task.followup_data ?? []).length > 0) return;
    if (task.priority === "High") return;

    setCarryForwardTaskData(task);
    setShowCarryForwardDialog(true);
  };

  const openAssignTaskPopup = (_task: Tasks) => {
    navigate("/task");
    goToTop();
  };

  const handleViewTask = (task: Tasks) => {
    setSelectedTaskData(task);
    setShowTaskViewModal(true);
  };

  const handleTaskActionSuccess = async (message: string) => {
    setShowTaskViewModal(false);
    setShowCompleteTaskDialog(false);
    setShowFollowUpDialog(false);
    setShowCarryForwardDialog(false);
    setShowEvidenceDialog(false);

    setSelectedTaskData(null);
    setCompleteTaskData(null);
    setFollowUpTaskData(null);
    setCarryForwardTaskData(null);
    setEvidenceTaskData(null);

    await refreshTaskData();

    showToast({
      severity: "success",
      summary: "Success",
      detail: message,
    });
  };

  const assignedContactBody = (rowData: Tasks) => {
    const contacts = rowData.assign;

    if (contacts?.length > 0) {
      return (
        <div
          className="project_card_contact_area mt-0 p-0 justify-content-center"
          onClick={() => openAssignTaskPopup(rowData)}
          style={{
            cursor:
              isTaskCompleted(rowData) ||
              isAlreadyCarryForwardRequestedForCurrentDate(rowData)
                ? "default"
                : "pointer",
          }}
        >
          {contacts.slice(0, 3).map((contact, index) => {
            const tooltipId = `home_task_contact_${rowData.task_id}_${index}`;

            return (
              <React.Fragment key={`${contact.id}_${index}`}>
                <Tooltip target={`#${tooltipId}`} />

                <div
                  id={tooltipId}
                  className="project_card_contact"
                  data-pr-tooltip={`${contact.first_name} ${contact.last_name}`}
                  data-pr-position="top"
                >
                  {contact.profile_image ? (
                    <img
                      src={contact.profile_image}
                      alt={`${contact.first_name} ${contact.last_name}`}
                    />
                  ) : (
                    <>
                      {contact.first_name?.[0]}
                      {contact.last_name?.[0]}
                    </>
                  )}
                </div>
              </React.Fragment>
            );
          })}

          {contacts.length > 3 && (
            <h6 className="project_card_contact_has_more">
              +{contacts.length - 3}
            </h6>
          )}
        </div>
      );
    }

    return (
      <button
        type="button"
        className="task_assign_plus_btn p-ripple"
        onClick={() => openAssignTaskPopup(rowData)}
      >
        <i className="bi bi-plus-lg"></i>
        <Ripple />
      </button>
    );
  };

  const priorityBody = (rowData: Tasks) => {
    const priority = rowData.priority;
    let colorCode = "";

    if (priority === "High") {
      colorCode = "#EF9A9A";
    } else if (priority === "Medium") {
      colorCode = "#FFEFBC";
    } else if (priority === "Low") {
      colorCode = "#B9F6CA";
    }

    return (
      <div className="flex_center">
        <span className="priority_label" style={{ backgroundColor: colorCode }}>
          {priority}
        </span>
      </div>
    );
  };

  const taskDateBody = (rowData: Tasks) => {
    const taskDate = getTaskDateValue(rowData);

    return <span className="text_no_wrap">{taskDate || "---"}</span>;
  };

  const statusBody = (rowData: Tasks) => {
    const currentStatus = getStatusLabel(rowData);

    return (
      <div className="flex_center">
        <Dropdown
          value={taskStatusOptions.find((item) => item.name === currentStatus)}
          onChange={(e: DropdownChangeEvent) =>
            handleStatusChange(rowData, e.value as TaskStatusOption | null)
          }
          options={taskStatusOptions}
          optionLabel="name"
          valueTemplate={(option) => statusValueTemplate(option, rowData)}
          itemTemplate={statusOptionTemplate}
          panelClassName="task_status_option_panel"
          className="task_status_dropdown"
          disabled={statusLoadingTaskId === rowData.task_id}
        />
      </div>
    );
  };
  /* ************************************************************************* */
  const handleClickOutside = (event: MouseEvent) => {
    if (
      rightPanelRef.current &&
      !rightPanelRef.current.contains(event.target as Node) &&
      panelToggleButtonRef.current &&
      !panelToggleButtonRef.current.contains(event.target as Node)
    ) {
      setShowRightPanel(false);
    }
  };

  useEffect(() => {
    profileData();

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [quickAccessFoldersData, setQuickAccessFoldersData] = useState<
    QuickAccessList[]
  >([]);

  useEffect(() => {
    const fetchData = async () => {
      setQuickAccessFoldersData(quickAccessList);
    };

    fetchData();
  }, []);

  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

  const handleShowInfoModal = () => {
    setShowInfoModal(true);
  };

  const handleCloseInfoModal = () => {
    setShowInfoModal(false);
  };

  /* Permission check */
  const blockedFeatureInfoPanel = useRef<OverlayPanel>(null);
  const viewOnlyFeatureInfoPanel = useRef<OverlayPanel>(null);
  const [moreOptionItems, setMoreOptionItems] = useState<MenuBarPermission[]>([]);
  const moreOptions = useAppSelector((state) => state.newPermission.permissions);

  useEffect(() => {
    dispatch(getAllNewPermissionsThunk());
  }, [dispatch]);

  useEffect(() => {
    if (moreOptions && moreOptions?.length > 0) {
      setMoreOptionItems(moreOptions);
    }
  }, [moreOptions]);

  const returnPermissionModel = (moreOptionName: string): MenuBarPermission | null => {
    const val = moreOptionItems.find((e) => e.menu_key_name === moreOptionName);
    if (val && val !== null) {
      return val;
    } else {
      return null;
    }
  }

  // check is lock
  const checkOptionLock = (option: MenuBarPermission | null): boolean => {
    if (option && option !== null) {
      if (option.have_feature) {
        return option.have_feature;
      } else {
        return option.view;
      }
    } else {
      return false;
    }
  }

  // Show lock symbol
  const showLockSymbol = (option: MenuBarPermission | null): boolean => {
    if (option && option !== null) {
      return (option.is_log && !option.view);
    } else {
      return false;
    }
  }

  // Show view only symbol
  const showViewOnlySymbol = (option: MenuBarPermission | null): boolean => {
    if (option && option !== null) {
      return (option.is_log && option.view);
    } else {
      return false;
    }
  }

  const notOptionNeed = (menu: MenuBarPermission | null): boolean => {
    if (menu && menu != null) {
      if (menu.have_feature === false) {
        return false;
      }
      else if (menu?.have_feature === true) {
        return true;
      } else if (menu?.view === true) {
        return true;
      } else if (menu?.is_log === false && menu.have_feature === false) {
        return false
      } else {
        return true
      }
    }
    else {
      return false;
    }

  }

  // const notOptionNeed = (option: MenuBarPermission | null): boolean => {
  //   if (option && option != null) {
  //     if (option?.have_feature === true) {
  //       return true;
  //     } else if (option?.view === true) {
  //       return true;
  //     } else if (option?.is_log === false && option.have_feature === false) {
  //       return false
  //     } else {
  //       return true
  //     }
  //   }
  //   else {
  //     return false;
  //   }
  // }

  const handleShowBlockedFeatureInfo = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (blockedFeatureInfoPanel.current) {
      blockedFeatureInfoPanel.current.hide();
      setTimeout(() => blockedFeatureInfoPanel.current?.show(e, e.currentTarget), 50);
    }
  }

  const handleCloseBlockedFeatureInfoPanel = (e: React.MouseEvent<HTMLElement>) => {
    if (blockedFeatureInfoPanel.current) {
      blockedFeatureInfoPanel.current.hide();
    }
  }

  const renderLockIcon = () => {
    return (
      <i className='ri ri-lock-fill lock_icon'
        onMouseOver={(e) => handleShowBlockedFeatureInfo(e)}
        onMouseLeave={(e) => handleCloseBlockedFeatureInfoPanel(e)}
      ></i>
    )
  }

  const handleShowViewOnlyFeatureInfo = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (viewOnlyFeatureInfoPanel.current) {
      viewOnlyFeatureInfoPanel.current.hide();
      setTimeout(() => viewOnlyFeatureInfoPanel.current?.show(e, e.currentTarget), 50);
    }
  }

  const handleCloseViewOnlyFeatureInfoPanel = (e: React.MouseEvent<HTMLElement>) => {
    if (viewOnlyFeatureInfoPanel.current) {
      viewOnlyFeatureInfoPanel.current.hide();
    }
  }

  const renderViewOnlyIcon = () => {
    return (
      <i className='ri-error-warning-fill lock_icon'
        onMouseOver={(e) => handleShowViewOnlyFeatureInfo(e)}
        onMouseLeave={(e) => handleCloseViewOnlyFeatureInfoPanel(e)}
      ></i>
    )
  }


  const DisabledMoreOption: React.FC<DisabledMoreOptionProps> = ({ label, icon }) => {
    return (
      <article className="more_field_link disabled p-ripple">
        <img
          src={icon}
          alt={label}
        />
        <span className="more_field_label">{label}</span>
      </article>
    );
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        <OverlayPanel ref={blockedFeatureInfoPanel} className="project_info_panel" dismissable>
          <p className='mb-0'>
            <i className='bi bi-info-circle me-1'></i>
            You do not have permission to access this feature.
          </p>
        </OverlayPanel>

        <OverlayPanel ref={viewOnlyFeatureInfoPanel} className="project_info_panel" dismissable>
          <p className='mb-0'>
            <i className='bi bi-info-circle me-1'></i>
            You only have permission to view this.
          </p>
        </OverlayPanel>

        {loading || loadingTask ? (
          <PageLoader />
        ) : error && errorMessage !== "" ? (
          <ErrorPage errorMessage={errorMessage} />
        ) : (
          <div className={`dash_container ${isPermissionQuickAccess && "has_right_panel"}`}>
            <div className="dash_content">
              <div className="dash_header main mt-0 mb-sm-4">
                <h5 className="dash_head main">
                  Hello!&nbsp;
                  {dataLoading ? (
                    <Skeleton className="user_name_loading" />
                  ) : (
                    <b>
                      {(userData?.first_name ?? '') + (userData?.last_name ? ` ${userData?.last_name}` : '')},
                    </b>
                  )}
                </h5>
                <h5 className="dash_date">{todayDate}</h5>
              </div>

              <Tooltip target=".project_type" />

              {isPermissionDCCCProjectInfo && (
                <div className="row">
                  <div className="col-12">
                    <article className="cc_pro_info_card">
                      <h6
                        dangerouslySetInnerHTML={{
                          __html:
                            "Take the stress out of project planning and people management.<br/>Traqdo helps teams work smarter together."
                        }}
                      />

                      <img
                        src="/assets/images/dashboard/project_info_img.svg"
                        alt="Current projects"
                        draggable={false}
                      />
                    </article>
                  </div>
                </div>
              )}

              {(isPermissionAllProjects || isPermissionCCProjects) && (
                <div className={`dash_header mt-0 ${isPermissionAllProjects ? 'justify-content-end' : ''} `}>
                  {!isPermissionAllProjects && (
                    <h5 className="dash_head">Projects</h5>
                  )}

                  <Link
                    to={"/project"}
                    onClick={() => {
                      goToTop();
                      localStorage.setItem('activeProjectTab', 'all');
                      localStorage.setItem("activeProjectViewType", 'My project');
                      localStorage.setItem("activeSharedFolderCategory", 'Others');
                    }}
                    className="dash_link p-ripple"
                  >
                    View all
                    <Ripple />
                  </Link>
                </div>
              )}


              {(isPermissionAllProjects || isPermissionCCProjects) && (
                <div className="row">
                  {isPermissionAllProjects && (
                    <div className="col-12 col-xl-3 col-lg-3 pe-lg-1 h-100">
                      <article className="dash_tile_square">
                        <div className="dash_tile_icon">
                          <i className="ri-stack-line"></i>
                        </div>
                        <h3>
                          {currentProjects.length.toString().padStart(2, "0")}
                        </h3>
                        <p>
                          Current <br /> project(s)
                        </p>
                        <img
                          src="/assets/images/dashboard/bulb.svg"
                          alt="Current projects"
                          draggable={false}
                        />
                      </article>
                    </div>
                  )}

                  <div className={`col-12 ${isPermissionAllProjects ? 'col-xl-9 col-lg-9' : ''}`}>
                    {projectsToShow?.length > 0 ? (
                      <div className="row dash_tile_row">
                        {projectsToShow.map((project) => (
                          <div
                            key={project.project_id}
                            className="col-12 col-sm-6 dash_tile_container"
                          >
                            <article className="dash_tile_rectangle">
                              <div className={`dash_tile_icon ${project.project_type === "Commercial" ? "cp" : "dp"}`}>
                                <i className="ri-stack-line"></i>
                              </div>
                              <div className="dash_tile_content">
                                <div className="dash_tile_header">
                                  <h6>{project.job_number}</h6>
                                  <p
                                    className="project_type"
                                    data-pr-tooltip={`${project.project_type} project`}
                                    data-pr-position="left"
                                  >
                                    {project.project_type === "Commercial" ? "CP" : "DP"}
                                  </p>
                                </div>
                                <h6 className="dash_tile_title">
                                  {project.address}
                                </h6>
                              </div>
                            </article>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="no_project_found_area">
                        <img
                          src="/assets/images/no_data/no_project.png"
                          alt=""
                          draggable={false}
                        />
                        <p>No projects found.</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {
                ((returnPermissionModel('tools') && notOptionNeed(returnPermissionModel('tools'))) ||
                  (returnPermissionModel('attendance') && notOptionNeed(returnPermissionModel('attendance'))) ||
                  (returnPermissionModel('shoppinglist') && notOptionNeed(returnPermissionModel('shoppinglist'))) ||
                  (returnPermissionModel('materials') && notOptionNeed(returnPermissionModel('materials'))) ||
                  (returnPermissionModel('projectspending') && notOptionNeed(returnPermissionModel('projectspending'))) ||
                  (returnPermissionModel('clientaccount') && notOptionNeed(returnPermissionModel('clientaccount'))) ||
                  (returnPermissionModel('finishingschedule') && notOptionNeed(returnPermissionModel('finishingschedule')))
                ) && (
                  <React.Fragment>
                    <div className="dash_header">
                      <h5 className="dash_head">More</h5>
                    </div>

                    <div className="more_fields_area">
                      <div className="row more_fields_row">
                        {/* Tools */}
                        {(returnPermissionModel('tools') && notOptionNeed(returnPermissionModel('tools'))) && (
                          <div className={`col-6 col-lg-4 col-md-4 col-sm-6 ${isPermissionQuickAccess ? " col-xl-4 " : " col-xl-3"} more_fields_column`}>
                            <div className="more_field_link_item">
                              {checkOptionLock(returnPermissionModel('tools')) ? (
                                <Link
                                  to={`/tools`}
                                  state={{ menuPermission: returnPermissionModel('tools') }}
                                  onClick={() => goToTop()}
                                  className="more_field_link p-ripple"
                                >
                                  <img
                                    src={`/assets/images/more/tools.svg`}
                                    alt={`Tools`}
                                  />
                                  <span className="more_field_label">Tools</span>
                                  <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }}
                                  />
                                </Link>
                              ) : (
                                <DisabledMoreOption
                                  icon='/assets/images/more/tools.svg'
                                  label='Tools'
                                />
                              )}

                              {(showLockSymbol(returnPermissionModel('tools'))) && (renderLockIcon())}
                              {(showViewOnlySymbol(returnPermissionModel('tools'))) && (renderViewOnlyIcon())}
                            </div>
                          </div>
                        )}

                        {/* Attendance */}
                        {(returnPermissionModel('attendance') && notOptionNeed(returnPermissionModel('attendance'))) && (
                          <div className={`col-6 col-lg-4 col-md-4 col-sm-6 ${isPermissionQuickAccess ? " col-xl-4 " : " col-xl-3"} more_fields_column`}>
                            <div className="more_field_link_item">
                              {(checkOptionLock(returnPermissionModel('attendance')) && checkHaveProject('attendance')) ? (
                                <Link
                                  to={`/attendance`}
                                  state={{ menuPermission: returnPermissionModel('attendance') }}
                                  onClick={() => {
                                    goToTop();
                                    localStorage.setItem('activeAttendanceView', 'Day');
                                  }}
                                  className="more_field_link p-ripple"
                                >
                                  <img
                                    src={`/assets/images/more/attendance.svg`}
                                    alt={`Attendance`}
                                  />
                                  <span className="more_field_label">Attendance</span>
                                  <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                </Link>
                              ) : (
                                <DisabledMoreOption
                                  icon='/assets/images/more/attendance.svg'
                                  label='Attendance'
                                />
                              )}

                              {(showLockSymbol(returnPermissionModel('attendance'))) && (renderLockIcon())}
                              {(showViewOnlySymbol(returnPermissionModel('attendance'))) && (renderViewOnlyIcon())}
                            </div>
                          </div>
                        )}

                        {/* Shopping list */}
                        {(returnPermissionModel('shoppinglist') && notOptionNeed(returnPermissionModel('shoppinglist'))) && (
                          <div className={`col-6 col-lg-4 col-md-4 col-sm-6 ${isPermissionQuickAccess ? " col-xl-4 " : " col-xl-3"} more_fields_column`}>
                            <div className="more_field_link_item">
                              {checkOptionLock(returnPermissionModel('shoppinglist')) ? (
                                <Link
                                  to={`/shopping-list`}
                                  state={{ menuPermission: returnPermissionModel('shoppinglist') }}
                                  onClick={goToTop}
                                  className="more_field_link p-ripple"
                                >
                                  <img
                                    src={`/assets/images/more/shopping_list.svg`}
                                    alt={`Shopping List`}
                                  />
                                  <span className="more_field_label">
                                    Shopping List
                                  </span>
                                  <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                </Link>
                              ) : (
                                <DisabledMoreOption
                                  icon='/assets/images/more/shopping_list.svg'
                                  label='Shopping List'
                                />
                              )}

                              {(showLockSymbol(returnPermissionModel('shoppinglist'))) && (renderLockIcon())}
                              {(showViewOnlySymbol(returnPermissionModel('shoppinglist'))) && (renderViewOnlyIcon())}
                            </div>
                          </div>
                        )}

                        {/* Materials */}
                        {(returnPermissionModel('materials') && notOptionNeed(returnPermissionModel('materials'))) && (
                          <div className={`col-6 col-lg-4 col-md-4 col-sm-6 ${isPermissionQuickAccess ? " col-xl-4 " : " col-xl-3"} more_fields_column`}>
                            <div className="more_field_link_item">
                              {(checkOptionLock(returnPermissionModel('materials')) && checkHaveProject('materials')) ? (
                                <Link
                                  to={`/materials/projects`}
                                  state={{ menuPermission: returnPermissionModel('materials') }}
                                  onClick={goToTop}
                                  className="more_field_link p-ripple"
                                >
                                  <img
                                    src={`/assets/images/more/materials.svg`}
                                    alt={`Materials`}
                                  />
                                  <span className="more_field_label">Materials</span>
                                  <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                </Link>
                              ) : (
                                <DisabledMoreOption
                                  icon='/assets/images/more/materials.svg'
                                  label='Materials'
                                />
                              )}

                              {(showLockSymbol(returnPermissionModel('materials'))) && (renderLockIcon())}
                              {(showViewOnlySymbol(returnPermissionModel('materials'))) && (renderViewOnlyIcon())}
                            </div>
                          </div>
                        )}

                        {/* Project spending */}
                        {(returnPermissionModel('projectspending') && notOptionNeed(returnPermissionModel('projectspending'))) && (
                          <div className={`col-6 col-lg-4 col-md-4 col-sm-6 ${isPermissionQuickAccess ? " col-xl-4 " : " col-xl-3"} more_fields_column`}>
                            <div className="more_field_link_item">
                              {(checkOptionLock(returnPermissionModel('projectspending')) && checkHaveProject('projectspending')) ? (
                                <Link
                                  to={'/project-spending/projects'}
                                  state={{ menuPermission: returnPermissionModel('projectspending') }}
                                  onClick={goToTop}
                                  className="more_field_link p-ripple"
                                >
                                  <img
                                    src={`/assets/images/more/project_spending.svg`}
                                    alt={`Project spending`}
                                  />
                                  <span className="more_field_label">
                                    Project spending
                                  </span>
                                  <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                </Link>
                              ) : (
                                <DisabledMoreOption
                                  icon='/assets/images/more/project_spending.svg'
                                  label='Project spending'
                                />
                              )}

                              {(showLockSymbol(returnPermissionModel('projectspending'))) && (renderLockIcon())}
                              {(showViewOnlySymbol(returnPermissionModel('projectspending'))) && (renderViewOnlyIcon())}
                            </div>
                          </div>
                        )}

                        {/* Client account */}
                        {(returnPermissionModel('clientaccount') && notOptionNeed(returnPermissionModel('clientaccount'))) && (
                          <div className={`col-6 col-lg-4 col-md-4 col-sm-6 ${isPermissionQuickAccess ? " col-xl-4 " : " col-xl-3"} more_fields_column`}>
                            <div className="more_field_link_item">
                              {(checkOptionLock(returnPermissionModel('clientaccount')) && checkHaveProject('clientaccount')) ? (
                                <Link
                                  to={`/client-account/projects`}
                                  state={{ menuPermission: returnPermissionModel('clientaccount') }}
                                  onClick={goToTop}
                                  className="more_field_link p-ripple"
                                >
                                  <img
                                    src={`/assets/images/more/client_account.svg`}
                                    alt={`Client account`}
                                  />
                                  <span className="more_field_label">
                                    Client account
                                  </span>
                                  <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                </Link>
                              ) : (
                                <DisabledMoreOption
                                  icon='/assets/images/more/client_account.svg'
                                  label='Client account'
                                />
                              )}

                              {(showLockSymbol(returnPermissionModel('clientaccount'))) && (renderLockIcon())}
                              {(showViewOnlySymbol(returnPermissionModel('clientaccount'))) && (renderViewOnlyIcon())}
                            </div>
                          </div>
                        )}

                        {/* Finishing schedlue */}
                        {(returnPermissionModel('finishingschedule') && notOptionNeed(returnPermissionModel('finishingschedule'))) && (
                          <div className={`col-6 col-lg-4 col-md-4 col-sm-6 ${isPermissionQuickAccess ? " col-xl-4 " : " col-xl-3"} more_fields_column`}>
                            <div className="more_field_link_item">
                              {checkOptionLock(returnPermissionModel('finishingschedule')) ? (
                                <Link
                                  to={`/finishing-shedule/projects`}
                                  state={{ menuPermission: returnPermissionModel('finishingschedule') }}
                                  onClick={() => {
                                    goToTop();
                                    localStorage.setItem("activeFSFeatureId", '');
                                    localStorage.setItem("activeBathroomLocationId", '');
                                    localStorage.setItem("activeTileLocationId", '');
                                    localStorage.setItem("activeLightLocationId", '');
                                    localStorage.setItem("activeOthersLocationId", '');
                                  }}
                                  className="more_field_link p-ripple"
                                >
                                  <img
                                    src={`/assets/images/more/finishing_shedule.svg`}
                                    alt={`Finishing schedlue`}
                                  />
                                  <span className="more_field_label">
                                    Finishing schedlue
                                  </span>
                                  <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                </Link>
                              ) : (
                                <DisabledMoreOption
                                  icon='/assets/images/more/finishing_shedule.svg'
                                  label='Finishing schedlue'
                                />
                              )}

                              {(showLockSymbol(returnPermissionModel('finishingschedule'))) && (renderLockIcon())}
                              {(showViewOnlySymbol(returnPermissionModel('finishingschedule'))) && (renderViewOnlyIcon())}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )
              }

              {/* Task */}
              {isPermissionTodoTask && (
                <div className="dash_header">
                  <h5 className="dash_head">Today's task</h5>
                  <Link
                    to={"/task"}
                    onClick={goToTop}
                    className="dash_link p-ripple"
                  >
                    View all
                    <Ripple />
                  </Link>
                </div>
              )}

              {isPermissionTodoTask && (
                <div className="dash_table_area">
                  {taskData?.length > 0 ? (
                    <DataTable
                      value={taskData}
                      size="small"
                      rows={5}
                      tableStyle={{ minWidth: "50rem" }}
                      className="page_table dash_table p-0"
                      emptyMessage="No task(s) assigned"
                    >
                      <Column
                        header="Reference"
                        headerClassName="text_purple"
                        body={(rowData: Tasks) => (
                          <small className="text_semi_bold">
                            {rowData.project_reference ? rowData.project_reference : "---"}
                          </small>
                        )}
                        style={{ width: "15%" }}
                      />

                      <Column
                        header="Task name"
                        headerClassName="text_purple"
                        body={(rowData: Tasks) => (
                          <button
                            type="button"
                            className="home_task_name_btn p-ripple"
                            onClick={() => handleViewTask(rowData)}
                          >
                            {rowData.task_name ? rowData.task_name : "--"}
                            <Ripple />
                          </button>
                        )}
                        style={{ width: "23%" }}
                      />

                      <Column
                        header="Task Date"
                        headerClassName="text_purple"
                        body={taskDateBody}
                        style={{ width: "12%" }}
                      />

                      <Column
                        header="Assign"
                        alignHeader="center"
                        headerClassName="text_purple"
                        body={assignedContactBody}
                        style={{ width: "15%" }}
                      />

                      <Column
                        header="Priority"
                        alignHeader="center"
                        headerClassName="text_purple"
                        body={priorityBody}
                        style={{ width: "15%" }}
                      />

                      <Column
                        header="Status"
                        alignHeader="center"
                        headerClassName="text_purple"
                        body={statusBody}
                        style={{ width: "15%" }}
                      />

                      {isPermissionTaskDetailsView && (
                        <Column
                          header=""
                          alignHeader="center"
                          body={(rowData: Tasks) => (
                            <button
                              type="button"
                              className="table_action_btn p-ripple"
                              onClick={() => handleViewTask(rowData)}
                            >
                              View
                              <Ripple />
                            </button>
                          )}
                          style={{ width: "5%" }}
                        />
                      )}
                    </DataTable>
                  ) : (
                    <div className="no_task_area">
                      <img
                        src="/assets/images/no_data/no-task.png"
                        alt="No task(s) assigned"
                      />
                      <h6>No task(s) assigned.</h6>
                    </div>
                  )}
                </div>
              )}
              {/*  */}
            </div>

            {isPermissionQuickAccess && (
              <React.Fragment>
                <div
                  className={`blurred_overlay ${showRightPanel && "show"}`}
                  onClick={() => setShowRightPanel(false)}
                ></div>

                <div
                  className={`right_panel ${showRightPanel ? "show" : ""}`}
                  ref={rightPanelRef}
                >
                  <button
                    className="panel_toggle_btn p-ripple"
                    onClick={handleToggleRightPanel}
                    ref={panelToggleButtonRef}
                  >
                    <i
                      className={`bi ${showRightPanel ? " bi-x" : " bi-list"}`}
                    ></i>
                    <Ripple />
                  </button>

                  <h5 className="dash_head is_top">Quick access</h5>

                  {loadingQuickAccessList ? (
                    <QuickAccessLoading />
                  ) : errorQuickAccessList ? (
                    <div className="quick_access_empty">
                      <img
                        src={errorDataIcon}
                        alt="Error!"
                      />
                      <span>{errorQuickAccessList}</span>
                    </div>
                  ) : (
                    <React.Fragment>
                      {quickAccessList?.length > 0 ? (
                        <div className="panel_item_container">
                          {quickAccessList.map((folder, index) => {
                            return (
                              <article
                                key={index}
                                className="panel_item_link p-ripple"
                                onClick={() => goToQuickAccessFolder(folder)}
                              >
                                <div className="panel_item_icon_area">
                                  <img
                                    src="/assets/images/dashboard/quick_link_icon.svg"
                                    alt={folder?.display_name}
                                  />
                                </div>
                                <h6 className="text-capitalize">
                                  {folder?.display_name}
                                </h6>
                                <Ripple />
                              </article>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="quick_access_empty">
                          <img
                            src="/assets/images/no_data/no_folder.svg"
                            alt="No folders found!"
                            draggable={false}
                          />
                          <span> No folder(s) found!</span>
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </div>
              </React.Fragment>
            )}
          </div>
        )}
      </div>

      <TaskDetailsDialog
        visible={showTaskViewModal}
        taskData={selectedTaskData}
        onHide={() => setShowTaskViewModal(false)}
        canEdit={isPermissionTaskEdit}
        canTaskCompleted={isPermissionTaskCompleted}
        onComplete={openCompleteTaskPopup}
        onFollowUp={openFollowUpPopup}
        onCarryForward={openCarryForwardPopup}
        onAssign={openAssignTaskPopup}
      />

      <CompleteTaskDialog
        visible={showCompleteTaskDialog}
        taskData={completeTaskData}
        onHide={() => setShowCompleteTaskDialog(false)}
        onSuccess={handleTaskActionSuccess}
        showToast={showToast}
      />

      <FollowUpDialog
        visible={showFollowUpDialog}
        taskData={followUpTaskData}
        onHide={() => setShowFollowUpDialog(false)}
        onSuccess={handleTaskActionSuccess}
        showToast={showToast}
      />

      <CarryForwardDialog
        visible={showCarryForwardDialog}
        taskData={carryForwardTaskData}
        onHide={() => setShowCarryForwardDialog(false)}
        onSuccess={handleTaskActionSuccess}
        showToast={showToast}
      />

      <CompletedEvidenceDialog
        visible={showEvidenceDialog}
        taskData={evidenceTaskData}
        onHide={() => {
          setShowEvidenceDialog(false);
          setEvidenceTaskData(null);
        }}
      />

      <InfoModal
        show={showInfoModal}
        onClose={handleCloseInfoModal}
        title="Stay Tuned!"
        info="This feature is currently under development on the web and will be available soon. In the meantime, you can use this feature on our mobile app."
        showAppLink={true}
      />
    </React.Fragment >
  );
};

export default DashBoard;
